module.exports = __webpack_public_path__ + "images/emoji/wavy_dash.3ffa668e1f8bf098feba.png";